import React, { useMemo } from 'react';

const ProjectRow = React.memo(({ project, index }) => (
  <div
    className="project-row"
    style={{
      marginBottom: '15px',
      padding: '15px',
      border: '1px solid #ddd',
      borderRadius: '5px',
      backgroundColor: '#fafafa'
    }}
  >
    <div
      className="project-header"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '10px'
      }}
    >
      <h4>Project {index + 1}</h4>
    </div>

    {/* Project Title and Status */}
    <div className="form-row">
      <div className="form-group">
        <label className="label">Project Title</label>
        <input
          type="text"
          value={project.projectTitle || ''}
          readOnly
          className="input"
          style={{
            backgroundColor: '#f5f5f5',
            cursor: 'not-allowed'
          }}
        />
      </div>

      <div className="form-group">
        <label className="label">Project Status</label>
        <select
          value={project.projectStatus || ''}
          disabled
          className="input select"
          style={{
            backgroundColor: '#f5f5f5',
            cursor: 'not-allowed'
          }}
        >
          <option value="">Select Status</option>
          <option value="Not Started">Not Started</option>
          <option value="In Progress">In Progress</option>
          <option value="Completed">Completed</option>
          <option value="On Hold">On Hold</option>
          <option value="Cancelled">Cancelled</option>
        </select>
      </div>
    </div>

    {/* Project Score */}
    <div className="form-row">
      <div className="form-group">
        <label className="label">Project Score</label>
        <div className="star-rating" style={{ cursor: 'default' }}>
          {[...Array(10)].map((_, starIndex) => {
            const value = starIndex + 1;
            return (
              <span
                key={value}
                className={`star ${value <= (project.projectScore || 0) ? 'filled' : ''}`}
                style={{
                  color: value <= (project.projectScore || 0) ? '#f5c518' : '#ccc',
                  fontSize: '20px',
                  cursor: 'default'
                }}
              >
                ★
              </span>
            );
          })}
        </div>
      </div>
    </div>
  </div>
));

const ProjectsSection = ({ formData, isExpanded = true }) => {
  const projects = useMemo(() => {
    return formData.projects && formData.projects.length > 0
      ? formData.projects
      : [{ projectTitle: '', projectStatus: '', projectScore: 0 }];
  }, [formData.projects]);

  return (
    <div className="form-section">
      {isExpanded && (
        <div className="section-content">
          {projects.map((project, index) => (
            <ProjectRow key={index} project={project} index={index} />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProjectsSection;
